var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-videohistory-stream__state mc-videohistory-stream__state--novideo"},[_c('div',[_c('img',{attrs:{"src":_vm.isWhitelabel()
          ? _vm.getAsset('secondaryLogo', 'sidebarMinimize')
          : require('@/assets/images/mceasy-large.png')}}),_c('p',[_vm._v(_vm._s(_vm.$t('trackVideo.state.noVideo')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }